import { Dialog } from "components/Dialog";
import { DocumentPreview } from "components/Document";

export const DocumentPreviewDialog = ({
  fileUrl,
  onClose,
}: {
  fileUrl: string;
  onClose: () => void;
}) => (
  <Dialog
    open
    onClose={onClose}
    fullWidth
    maxWidth="lg"
    // A fixed height, so the preview scrolls inside and draws pages as they near.
    sx={{ "& .MuiDialog-paper": { height: "90vh" } }}
    title="Document Preview"
    noPrimaryAction
  >
    <DocumentPreview fileUrl={fileUrl} />
  </Dialog>
);
